var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundLong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "125.694vw",
    height: "149.835vh",
    viewBox: "0 0 1810 1362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2711 536.163C16.2391 455.779 65.1644 374.375 145.549 354.343L1421.91 36.2711C1502.29 16.2392 1583.7 65.1644 1603.73 145.549L1773.13 825.332C1793.16 905.716 1744.24 987.12 1663.86 1007.15L387.494 1325.22C307.11 1345.26 225.707 1296.33 205.675 1215.95L36.2711 536.163Z",
    fill: "#0D1E42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_7_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.028 427.461L245.4 400.87C254.128 398.624 263.034 403.887 265.28 412.618L271.099 435.238L166.686 462.097C158.532 464.195 150.213 459.279 148.115 451.123L142.028 427.461Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.163 435.126L374.535 408.535C383.264 406.289 392.17 411.552 394.415 420.283L400.234 442.903L295.821 469.762C287.667 471.86 279.348 466.944 277.25 458.788L271.163 435.126Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.234 442.903L503.606 416.312C512.335 414.067 521.241 419.33 523.486 428.06L529.305 450.681L424.892 477.54C416.738 479.637 408.419 474.721 406.321 466.566L400.234 442.903Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.307 450.688L632.678 424.097C641.407 421.852 650.313 427.115 652.559 435.845L658.378 458.466L553.964 485.324C545.811 487.422 537.492 482.506 535.394 474.35L529.307 450.688Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.378 458.466L761.749 431.875C770.478 429.629 779.384 434.892 781.63 443.623L787.449 466.243L683.036 493.102C674.882 495.2 666.563 490.284 664.465 482.128L658.378 458.466Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.444 466.283L890.815 439.692C899.544 437.446 908.45 442.709 910.696 451.44L916.515 474.06L812.101 500.919C803.947 503.017 795.628 498.101 793.53 489.945L787.444 466.283Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.515 474.06L1019.89 447.469C1028.61 445.224 1037.52 450.487 1039.77 459.217L1045.59 481.838L941.172 508.697C933.018 510.794 924.699 505.878 922.601 497.723L916.515 474.06Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.59 481.836L1148.96 455.245C1157.69 453 1166.6 458.262 1168.84 466.993L1174.66 489.613L1070.25 516.472C1062.1 518.57 1053.78 513.654 1051.68 505.498L1045.59 481.836Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.66 489.614L1278.03 463.023C1286.76 460.777 1295.67 466.04 1297.92 474.771L1303.73 497.391L1199.32 524.25C1191.17 526.348 1182.85 521.432 1180.75 513.276L1174.66 489.614Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.74 497.389L1407.11 470.798C1415.84 468.553 1424.75 473.816 1426.99 482.546L1432.81 505.167L1328.4 532.026C1320.25 534.123 1311.93 529.207 1309.83 521.051L1303.74 497.389Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.81 505.167L1536.18 478.576C1544.91 476.33 1553.82 481.593 1556.06 490.324L1561.88 512.944L1457.47 539.803C1449.32 541.901 1441 536.985 1438.9 528.829L1432.81 505.167Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1562.1 513.179L1665.48 486.588C1674.2 484.342 1683.11 489.605 1685.36 498.336L1691.18 520.956L1586.76 547.815C1578.61 549.913 1570.29 544.997 1568.19 536.841L1562.1 513.179Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.531 373.809L612.902 347.218C621.631 344.972 630.537 350.235 632.783 358.966L638.602 381.586L534.188 408.445C526.034 410.543 517.716 405.627 515.618 397.471L509.531 373.809Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.602 381.586L741.973 354.995C750.702 352.75 759.608 358.013 761.854 366.743L767.672 389.364L663.259 416.223C655.105 418.32 646.786 413.404 644.688 405.249L638.602 381.586Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.674 389.371L871.046 362.78C879.775 360.535 888.681 365.798 890.926 374.528L896.745 397.149L792.332 424.008C784.178 426.105 775.859 421.189 773.761 413.033L767.674 389.371Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.738 397.181L1000.11 370.59C1008.84 368.345 1017.74 373.608 1019.99 382.338L1025.81 404.959L921.396 431.818C913.242 433.915 904.923 428.999 902.825 420.843L896.738 397.181Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.81 404.966L1129.18 378.375C1137.91 376.129 1146.82 381.392 1149.06 390.123L1154.88 412.743L1050.47 439.602C1042.31 441.7 1034 436.784 1031.9 428.628L1025.81 404.966Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.89 412.742L1258.26 386.151C1266.99 383.905 1275.9 389.168 1278.14 397.899L1283.96 420.519L1179.55 447.378C1171.39 449.476 1163.07 444.56 1160.98 436.404L1154.89 412.742Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.96 420.519L1387.33 393.928C1396.06 391.683 1404.97 396.946 1407.21 405.676L1413.03 428.297L1308.62 455.156C1300.46 457.253 1292.14 452.337 1290.05 444.181L1283.96 420.519Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.04 428.295L1516.41 401.704C1525.14 399.458 1534.04 404.721 1536.29 413.452L1542.11 436.072L1437.7 462.931C1429.54 465.029 1421.22 460.113 1419.12 451.957L1413.04 428.295Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.11 436.072L1645.48 409.481C1654.21 407.236 1663.12 412.499 1665.36 421.229L1671.18 443.85L1566.77 470.709C1558.61 472.806 1550.29 467.89 1548.2 459.735L1542.11 436.072Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7888 496.444L136.16 469.853C144.889 467.608 153.795 472.871 156.041 481.602L161.86 504.222L57.4464 531.081C49.2925 533.178 40.9736 528.262 38.8756 520.107L32.7888 496.444Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.862 504.229L265.233 477.638C273.962 475.393 282.868 480.656 285.114 489.386L290.932 512.007L186.519 538.866C178.365 540.963 170.046 536.047 167.948 527.892L161.862 504.229Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.932 512.007L394.304 485.416C403.033 483.17 411.939 488.433 414.184 497.164L420.003 519.784L315.59 546.643C307.436 548.741 299.117 543.825 297.019 535.669L290.932 512.007Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.998 519.824L523.37 493.233C532.099 490.988 541.005 496.25 543.25 504.981L549.069 527.601L444.656 554.46C436.502 556.558 428.183 551.642 426.085 543.486L419.998 519.824Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.076 527.6L652.448 501.009C661.176 498.763 670.082 504.026 672.328 512.757L678.147 535.377L573.734 562.236C565.58 564.334 557.261 559.418 555.163 551.262L549.076 527.6Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.147 535.377L781.519 508.786C790.247 506.541 799.153 511.804 801.399 520.534L807.218 543.155L702.805 570.014C694.651 572.111 686.332 567.195 684.234 559.039L678.147 535.377Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.225 543.153L910.597 516.562C919.325 514.317 928.231 519.579 930.477 528.31L936.296 550.93L831.883 577.789C823.729 579.887 815.41 574.971 813.312 566.815L807.225 543.153Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.296 550.93L1039.67 524.339C1048.4 522.094 1057.3 527.357 1059.55 536.088L1065.37 558.708L960.954 585.567C952.8 587.664 944.481 582.748 942.383 574.593L936.296 550.93Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.37 558.708L1168.74 532.117C1177.47 529.872 1186.37 535.134 1188.62 543.865L1194.44 566.485L1090.02 593.344C1081.87 595.442 1073.55 590.526 1071.45 582.37L1065.37 558.708Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.45 566.484L1297.82 539.893C1306.55 537.647 1315.45 542.91 1317.7 551.641L1323.52 574.261L1219.1 601.12C1210.95 603.218 1202.63 598.302 1200.53 590.146L1194.45 566.484Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.52 574.261L1426.89 547.67C1435.62 545.425 1444.52 550.688 1446.77 559.418L1452.59 582.039L1348.17 608.898C1340.02 610.995 1331.7 606.079 1329.6 597.923L1323.52 574.261Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.59 582.039L1555.96 555.448C1564.69 553.202 1573.59 558.465 1575.84 567.196L1581.66 589.816L1477.24 616.675C1469.09 618.773 1460.77 613.857 1458.67 605.701L1452.59 582.039Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.65 589.856L1685.02 563.265C1693.75 561.02 1702.66 566.282 1704.9 575.013L1710.72 597.633L1606.31 624.492C1598.16 626.59 1589.84 621.674 1587.74 613.518L1581.65 589.856Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5525 573.335L155.924 546.744C164.653 544.498 173.559 549.761 175.805 558.492L181.623 581.112L77.2101 607.971C69.0562 610.069 60.7354 605.145 58.6393 596.997L52.5525 573.335Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.623 581.112L284.995 554.521C293.724 552.276 302.63 557.539 304.875 566.269L310.694 588.89L206.281 615.749C198.127 617.846 189.808 612.93 187.71 604.774L181.623 581.112Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.694 588.89L414.066 562.299C422.795 560.053 431.701 565.316 433.946 574.047L439.765 596.667L335.352 623.526C327.198 625.624 318.879 620.708 316.781 612.552L310.694 588.89Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.76 596.707L543.132 570.116C551.86 567.871 560.766 573.133 563.012 581.864L568.831 604.484L464.418 631.343C456.264 633.441 447.945 628.525 445.847 620.369L439.76 596.707Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.84 604.49L672.212 577.899C680.94 575.653 689.846 580.916 692.092 589.647L697.911 612.267L593.498 639.126C585.344 641.224 577.025 636.308 574.927 628.152L568.84 604.49Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.911 612.267L801.282 585.676C810.011 583.431 818.917 588.694 821.163 597.424L826.982 620.045L722.568 646.904C714.414 649.001 706.095 644.085 703.997 635.93L697.911 612.267Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.989 620.043L930.361 593.452C939.089 591.207 947.995 596.469 950.241 605.2L956.06 627.82L851.647 654.679C843.493 656.777 835.174 651.861 833.076 643.705L826.989 620.043Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.06 627.82L1059.43 601.229C1068.16 598.984 1077.07 604.247 1079.31 612.978L1085.13 635.598L980.717 662.457C972.563 664.554 964.245 659.639 962.147 651.483L956.06 627.82Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.13 635.598L1188.5 609.007C1197.23 606.762 1206.14 612.025 1208.38 620.755L1214.2 643.376L1109.79 670.235C1101.63 672.332 1093.32 667.416 1091.22 659.26L1085.13 635.598Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.21 643.374L1317.58 616.783C1326.31 614.537 1335.22 619.8 1337.46 628.531L1343.28 651.151L1238.87 678.01C1230.71 680.108 1222.39 675.192 1220.3 667.036L1214.21 643.374Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.28 651.151L1446.65 624.56C1455.38 622.315 1464.29 627.578 1466.53 636.308L1472.35 658.929L1367.94 685.788C1359.78 687.885 1351.46 682.969 1349.37 674.814L1343.28 651.151Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.35 658.929L1575.72 632.338C1584.45 630.092 1593.36 635.355 1595.6 644.086L1601.42 666.706L1497.01 693.565C1488.85 695.663 1480.54 690.747 1478.44 682.591L1472.35 658.929Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1601.42 666.746L1704.79 640.155C1713.52 637.91 1722.42 643.173 1724.67 651.903L1730.49 674.524L1626.07 701.383C1617.92 703.48 1609.6 698.564 1607.5 690.408L1601.42 666.746Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3556 650.23L175.727 623.639C184.456 621.393 193.362 626.656 195.608 635.387L201.426 658.007L97.0132 684.866C88.8593 686.964 80.5385 682.041 78.4406 673.885L72.3538 650.223L72.3556 650.23Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.427 658.007L304.798 631.416C313.527 629.171 322.433 634.434 324.679 643.164L330.497 665.785L226.084 692.644C217.93 694.741 209.611 689.825 207.513 681.67L201.427 658.007Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.497 665.785L433.869 639.194C442.598 636.949 451.504 642.211 453.749 650.942L459.568 673.562L355.155 700.421C347.001 702.519 338.682 697.603 336.584 689.447L330.497 665.785Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.571 673.6L562.942 647.009C571.671 644.764 580.577 650.027 582.823 658.757L588.641 681.378L484.228 708.237C476.074 710.334 467.755 705.418 465.657 697.263L459.571 673.6Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.641 681.378L692.013 654.787C700.742 652.541 709.648 657.804 711.893 666.535L717.712 689.155L613.299 716.014C605.145 718.112 596.826 713.196 594.728 705.04L588.641 681.378Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.714 689.162L821.086 662.571C829.814 660.326 838.72 665.589 840.966 674.32L846.785 696.94L742.372 723.799C734.218 725.896 725.899 720.98 723.801 712.825L717.714 689.162Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.792 696.938L950.164 670.347C958.892 668.102 967.798 673.365 970.044 682.095L975.863 704.716L871.45 731.575C863.296 733.672 854.977 728.756 852.879 720.6L846.792 696.938Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.863 704.716L1079.23 678.125C1087.96 675.879 1096.87 681.142 1099.12 689.873L1104.93 712.493L1000.52 739.352C992.367 741.45 984.048 736.534 981.95 728.378L975.863 704.716Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.94 712.484L1208.31 685.893C1217.04 683.648 1225.95 688.911 1228.19 697.641L1234.01 720.262L1129.6 747.121C1121.44 749.218 1113.12 744.302 1111.03 736.147L1104.94 712.484Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.01 720.262L1337.38 693.671C1346.11 691.426 1355.02 696.688 1357.26 705.419L1363.08 728.039L1258.67 754.898C1250.51 756.996 1242.19 752.08 1240.1 743.924L1234.01 720.262Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.08 728.046L1466.45 701.455C1475.18 699.21 1484.09 704.473 1486.34 713.204L1492.15 735.824L1387.74 762.683C1379.59 764.78 1371.27 759.864 1369.17 751.709L1363.08 728.046Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.15 735.824L1595.53 709.233C1604.25 706.988 1613.16 712.251 1615.41 720.981L1621.22 743.602L1516.81 770.461C1508.66 772.558 1500.34 767.642 1498.24 759.486L1492.15 735.824Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.22 743.634L1724.59 717.043C1733.32 714.798 1742.22 720.061 1744.47 728.791L1750.29 751.412L1645.88 778.271C1637.72 780.368 1629.4 775.452 1627.3 767.296L1621.22 743.634Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1299 727.102L195.501 700.511C204.23 698.265 213.136 703.528 215.382 712.259L221.201 734.879L116.787 761.738C108.634 763.836 100.315 758.92 98.2167 750.764L92.1299 727.102Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.201 734.879L324.573 708.288C333.301 706.043 342.207 711.306 344.453 720.036L350.272 742.657L245.859 769.516C237.705 771.613 229.386 766.697 227.288 758.542L221.201 734.879Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.272 742.657L453.643 716.066C462.372 713.821 471.278 719.083 473.524 727.814L479.343 750.434L374.929 777.293C366.775 779.391 358.457 774.475 356.359 766.319L350.272 742.657Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.337 750.474L582.709 723.883C591.438 721.638 600.344 726.901 602.589 735.631L608.408 758.252L503.995 785.111C495.841 787.208 487.522 782.292 485.424 774.136L479.337 750.474Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.417 758.257L711.789 731.666C720.518 729.421 729.424 734.684 731.67 743.414L737.488 766.034L633.075 792.893C624.921 794.991 616.602 790.075 614.504 781.919L608.417 758.257Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.489 766.034L840.86 739.443C849.589 737.198 858.495 742.461 860.741 751.192L866.559 773.812L762.146 800.671C753.992 802.768 745.673 797.852 743.575 789.697L737.489 766.034Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.566 773.81L969.938 747.219C978.667 744.974 987.573 750.237 989.818 758.967L995.637 781.588L891.224 808.447C883.07 810.544 874.751 805.628 872.653 797.472L866.566 773.81Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.637 781.588L1099.01 754.997C1107.74 752.751 1116.64 758.014 1118.89 766.745L1124.71 789.365L1020.29 816.224C1012.14 818.322 1003.82 813.406 1001.72 805.25L995.637 781.588Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.71 789.365L1228.08 762.774C1236.81 760.529 1245.71 765.792 1247.96 774.522L1253.78 797.143L1149.37 824.002C1141.21 826.099 1132.89 821.183 1130.8 813.028L1124.71 789.365Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.79 797.141L1357.16 770.55C1365.89 768.305 1374.79 773.568 1377.04 782.298L1382.86 804.919L1278.44 831.778C1270.29 833.875 1261.97 828.959 1259.87 820.803L1253.79 797.141Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.86 804.918L1486.23 778.327C1494.96 776.082 1503.86 781.345 1506.11 790.076L1511.93 812.696L1407.51 839.555C1399.36 841.652 1391.04 836.736 1388.94 828.581L1382.86 804.918Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.93 812.696L1615.3 786.105C1624.03 783.86 1632.93 789.123 1635.18 797.853L1641 820.474L1536.59 847.333C1528.43 849.43 1520.11 844.514 1518.01 836.358L1511.93 812.696Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.99 820.513L1744.37 793.922C1753.09 791.677 1762 796.94 1764.25 805.67L1770.06 828.291L1665.65 855.15C1657.5 857.247 1649.18 852.331 1647.08 844.176L1640.99 820.513Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.904 803.974L215.276 777.383C224.005 775.137 232.911 780.4 235.156 789.131L240.975 811.751L136.562 838.61C128.408 840.708 120.089 835.792 117.991 827.636L111.904 803.974Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.975 811.751L344.347 785.16C353.075 782.915 361.981 788.178 364.227 796.908L370.046 819.529L265.633 846.388C257.479 848.485 249.16 843.569 247.062 835.414L240.975 811.751Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.046 819.529L473.418 792.938C482.146 790.693 491.052 795.956 493.298 804.686L499.117 827.306L394.704 854.165C386.55 856.263 378.231 851.347 376.133 843.191L370.046 819.529Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.112 827.346L602.483 800.755C611.212 798.51 620.118 803.773 622.364 812.503L628.183 835.124L523.769 861.983C515.616 864.08 507.297 859.164 505.199 851.008L499.112 827.346Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.192 835.129L731.564 808.538C740.292 806.293 749.198 811.555 751.444 820.286L757.263 842.906L652.85 869.765C644.696 871.863 636.377 866.947 634.279 858.791L628.192 835.129Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.263 842.906L860.634 816.315C869.363 814.07 878.269 819.333 880.515 828.064L886.334 850.684L781.92 877.543C773.766 879.64 765.447 874.724 763.35 866.569L757.263 842.906Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.341 850.682L989.712 824.091C998.441 821.846 1007.35 827.109 1009.59 835.839L1015.41 858.46L910.998 885.319C902.845 887.416 894.526 882.5 892.428 874.344L886.341 850.682Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.41 858.46L1118.78 831.869C1127.51 829.623 1136.42 834.886 1138.66 843.617L1144.48 866.237L1040.07 893.096C1031.92 895.194 1023.6 890.278 1021.5 882.122L1015.41 858.46Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.48 866.237L1247.85 839.646C1256.58 837.401 1265.49 842.664 1267.73 851.394L1273.55 874.015L1169.14 900.874C1160.99 902.971 1152.67 898.055 1150.57 889.9L1144.48 866.237Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.56 874.013L1376.93 847.422C1385.66 845.177 1394.57 850.44 1396.81 859.17L1402.63 881.791L1298.22 908.65C1290.06 910.747 1281.75 905.831 1279.65 897.675L1273.56 874.013Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.63 881.791L1506 855.2C1514.73 852.954 1523.64 858.217 1525.88 866.948L1531.7 889.568L1427.29 916.427C1419.14 918.525 1410.82 913.609 1408.72 905.453L1402.63 881.791Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.7 889.568L1635.07 862.977C1643.8 860.732 1652.71 865.995 1654.95 874.725L1660.77 897.346L1556.36 924.205C1548.21 926.302 1539.89 921.386 1537.79 913.23L1531.7 889.568Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.77 897.385L1764.14 870.794C1772.87 868.549 1781.77 873.812 1784.02 882.542L1789.84 905.163L1685.43 932.022C1677.27 934.119 1668.95 929.203 1666.85 921.048L1660.77 897.385Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74 881.083L235.111 854.492C243.84 852.247 252.746 857.509 254.992 866.24L260.811 888.86L156.397 915.719C148.243 917.817 139.925 912.901 137.827 904.745L131.74 881.083Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.812 888.868L364.184 862.277C372.913 860.031 381.819 865.294 384.065 874.025L389.883 896.645L285.47 923.504C277.316 925.602 268.997 920.686 266.899 912.53L260.812 888.868Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.883 896.645L493.255 870.054C501.984 867.809 510.89 873.072 513.135 881.802L518.954 904.423L414.541 931.282C406.387 933.379 398.068 928.463 395.97 920.308L389.883 896.645Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.949 904.462L622.321 877.871C631.049 875.626 639.955 880.889 642.201 889.62L648.02 912.24L543.607 939.099C535.453 941.196 527.134 936.28 525.036 928.125L518.949 904.462Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.027 912.238L751.399 885.647C760.127 883.402 769.033 888.665 771.279 897.395L777.098 920.016L672.685 946.875C664.531 948.972 656.212 944.056 654.114 935.9L648.027 912.238Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.098 920.016L880.47 893.425C889.198 891.179 898.104 896.442 900.35 905.173L906.169 927.793L801.756 954.652C793.602 956.75 785.283 951.834 783.185 943.678L777.098 920.016Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.178 927.799L1009.55 901.208C1018.28 898.962 1027.18 904.225 1029.43 912.956L1035.25 935.576L930.836 962.435C922.682 964.533 914.363 959.617 912.265 951.461L906.178 927.799Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.25 935.576L1138.62 908.985C1147.35 906.74 1156.26 912.003 1158.5 920.733L1164.32 943.354L1059.91 970.213C1051.75 972.31 1043.43 967.394 1041.34 959.238L1035.25 935.576Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.32 943.346L1267.69 916.755C1276.42 914.51 1285.32 919.773 1287.57 928.504L1293.39 951.124L1188.98 977.983C1180.82 980.08 1172.5 975.165 1170.4 967.009L1164.32 943.346Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.4 951.122L1396.77 924.531C1405.5 922.286 1414.4 927.549 1416.65 936.279L1422.47 958.9L1318.05 985.759C1309.9 987.856 1301.58 982.94 1299.48 974.784L1293.4 951.122Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.47 958.9L1525.84 932.309C1534.57 930.063 1543.47 935.326 1545.72 944.057L1551.54 966.677L1447.12 993.536C1438.97 995.634 1430.65 990.718 1428.55 982.562L1422.47 958.9Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1551.54 966.677L1654.91 940.086C1663.64 937.841 1672.54 943.104 1674.79 951.834L1680.61 974.455L1576.2 1001.31C1568.04 1003.41 1559.72 998.495 1557.62 990.339L1551.54 966.677Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.525 957.998L254.897 931.407C263.625 929.162 272.531 934.425 274.777 943.155L280.596 965.776L176.183 992.635C168.029 994.732 159.71 989.816 157.612 981.66L151.525 957.998Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.596 965.776L383.968 939.185C392.696 936.939 401.602 942.202 403.848 950.933L409.667 973.553L305.261 1000.41C297.107 1002.51 288.788 997.592 286.69 989.436L280.603 965.774L280.596 965.776Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.667 973.553L513.038 946.962C521.767 944.717 530.673 949.98 532.919 958.71L538.738 981.331L434.324 1008.19C426.17 1010.29 417.852 1005.37 415.754 997.216L409.667 973.553Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.74 981.369L642.112 954.778C650.84 952.532 659.746 957.795 661.992 966.526L667.811 989.146L563.398 1016.01C555.244 1018.1 546.925 1013.19 544.827 1005.03L538.74 981.369Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.812 989.153L771.184 962.562C779.913 960.317 788.819 965.58 791.065 974.31L796.883 996.931L692.47 1023.79C684.316 1025.89 675.997 1020.97 673.899 1012.82L667.812 989.153Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.891 996.929L900.262 970.338C908.991 968.093 917.897 973.356 920.143 982.086L925.961 1004.71L821.548 1031.57C813.394 1033.66 805.075 1028.75 802.977 1020.59L796.891 996.929Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.961 1004.71L1029.33 978.116C1038.06 975.87 1046.97 981.133 1049.21 989.864L1055.03 1012.48L950.619 1039.34C942.465 1041.44 934.146 1036.52 932.048 1028.37L925.961 1004.71Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.03 1012.48L1158.4 985.893C1167.13 983.648 1176.04 988.911 1178.28 997.641L1184.1 1020.26L1079.69 1047.12C1071.54 1049.22 1063.22 1044.3 1061.12 1036.15L1055.03 1012.48Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.11 1020.26L1287.48 993.669C1296.21 991.423 1305.12 996.686 1307.36 1005.42L1313.18 1028.04L1208.77 1054.9C1200.61 1056.99 1192.3 1052.08 1190.2 1043.92L1184.11 1020.26Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.18 1028.04L1416.55 1001.45C1425.28 999.201 1434.19 1004.46 1436.43 1013.19L1442.25 1035.81L1337.84 1062.67C1329.69 1064.77 1321.37 1059.86 1319.27 1051.7L1313.18 1028.04Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.301 1034.88L274.673 1008.29C283.401 1006.04 292.308 1011.3 294.553 1020.03L300.372 1042.65L195.966 1069.51C187.812 1071.61 179.493 1066.69 177.395 1058.54L171.308 1034.88L171.301 1034.88Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.372 1042.65L403.744 1016.06C412.472 1013.82 421.378 1019.08 423.624 1027.81L429.443 1050.43L325.037 1077.29C316.883 1079.39 308.564 1074.47 306.466 1066.32L300.379 1042.65L300.372 1042.65Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.443 1050.43L532.815 1023.84C541.543 1021.6 550.449 1026.86 552.695 1035.59L558.514 1058.21L454.101 1085.07C445.947 1087.17 437.628 1082.25 435.53 1074.09L429.443 1050.43Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.516 1058.25L661.888 1031.66C670.616 1029.41 679.522 1034.67 681.768 1043.4L687.587 1066.03L583.174 1092.88C575.02 1094.98 566.701 1090.07 564.603 1081.91L558.516 1058.25Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.587 1066.03L790.959 1039.43C799.687 1037.19 808.593 1042.45 810.839 1051.18L816.658 1073.8L712.245 1100.66C704.091 1102.76 695.772 1097.84 693.674 1089.69L687.587 1066.03Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.667 1073.81L920.038 1047.22C928.767 1044.97 937.673 1050.23 939.919 1058.97L945.738 1081.59L841.324 1108.44C833.17 1110.54 824.852 1105.63 822.754 1097.47L816.667 1073.81Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.738 1081.59L1049.11 1054.99C1057.84 1052.75 1066.74 1058.01 1068.99 1066.74L1074.81 1089.36L970.395 1116.22C962.241 1118.32 953.922 1113.4 951.824 1105.25L945.738 1081.59Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.82 1089.36L1178.19 1062.77C1186.92 1060.52 1195.82 1065.79 1198.07 1074.52L1203.89 1097.14L1099.47 1124C1091.32 1126.1 1083 1121.18 1080.9 1113.02L1074.82 1089.36Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.089 1111.8L294.46 1085.21C303.189 1082.96 312.095 1088.23 314.341 1096.96L320.159 1119.58L215.746 1146.44C207.592 1148.53 199.273 1143.62 197.175 1135.46L191.089 1111.8Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.161 1119.58L423.533 1092.99C432.261 1090.75 441.167 1096.01 443.413 1104.74L449.232 1127.36L344.819 1154.22C336.665 1156.32 328.346 1151.4 326.248 1143.25L320.161 1119.58Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.232 1127.36L552.604 1100.77C561.332 1098.53 570.238 1103.79 572.484 1112.52L578.303 1135.14L473.89 1162C465.736 1164.1 457.417 1159.18 455.319 1151.02L449.232 1127.36Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.305 1135.18L681.677 1108.59C690.405 1106.34 699.311 1111.6 701.557 1120.33L707.376 1142.95L602.963 1169.81C594.809 1171.91 586.49 1167 584.392 1158.84L578.305 1135.18Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.376 1142.95L810.748 1116.36C819.476 1114.12 828.382 1119.38 830.628 1128.11L836.447 1150.73L732.034 1177.59C723.88 1179.69 715.561 1174.77 713.463 1166.62L707.376 1142.95Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.447 1150.73L939.819 1124.14C948.547 1121.9 957.453 1127.16 959.699 1135.89L965.518 1158.51L861.105 1185.37C852.951 1187.47 844.632 1182.55 842.534 1174.39L836.447 1150.73Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.881 1188.74L314.253 1162.15C322.982 1159.91 331.888 1165.17 334.133 1173.9L339.952 1196.52L235.539 1223.38C227.385 1225.48 219.066 1220.56 216.968 1212.41L210.881 1188.74Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.952 1196.52L443.324 1169.93C452.052 1167.68 460.958 1172.95 463.204 1181.68L469.023 1204.3L364.61 1231.16C356.456 1233.26 348.137 1228.34 346.039 1220.18L339.952 1196.52Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.023 1204.3L572.395 1177.71C581.123 1175.46 590.029 1180.73 592.275 1189.46L598.094 1212.08L493.681 1238.94C485.527 1241.03 477.208 1236.12 475.11 1227.96L469.023 1204.3Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.089 1212.12L701.46 1185.52C710.189 1183.28 719.095 1188.54 721.341 1197.27L727.16 1219.89L622.746 1246.75C614.593 1248.85 606.274 1243.93 604.176 1235.78L598.089 1212.12Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.621 1265.57L333.993 1238.98C342.722 1236.73 351.628 1242 353.873 1250.73L359.692 1273.35L255.279 1300.21C247.125 1302.3 238.806 1297.39 236.708 1289.23L230.621 1265.57Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.694 1273.36L463.065 1246.76C471.794 1244.52 480.7 1249.78 482.946 1258.51L488.765 1281.13L384.351 1307.99C376.198 1310.09 367.879 1305.17 365.781 1297.02L359.694 1273.36Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.116 243.513L960.488 216.922C969.216 214.677 978.122 219.94 980.368 228.67L986.187 251.291L881.774 278.15C873.62 280.247 865.301 275.331 863.203 267.176L857.116 243.513Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.253 251.186L1089.62 224.595C1098.35 222.349 1107.26 227.612 1109.51 236.343L1115.32 258.963L1010.91 285.822C1002.76 287.92 994.438 283.004 992.34 274.848L986.253 251.186Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.32 258.963L1218.7 232.372C1227.42 230.127 1236.33 235.39 1238.58 244.12L1244.4 266.741L1139.98 293.6C1131.83 295.697 1123.51 290.781 1121.41 282.626L1115.32 258.963Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.4 266.779L1347.77 240.188C1356.5 237.942 1365.4 243.205 1367.65 251.936L1373.47 274.556L1269.05 301.415C1260.9 303.513 1252.58 298.597 1250.48 290.441L1244.4 266.779Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.47 274.556L1476.84 247.965C1485.57 245.72 1494.47 250.983 1496.72 259.713L1502.54 282.334L1398.13 309.193C1389.97 311.29 1381.65 306.374 1379.55 298.219L1373.47 274.556Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502.55 282.332L1605.92 255.741C1614.65 253.496 1623.55 258.759 1625.8 267.489L1631.62 290.109L1527.2 316.968C1519.05 319.066 1510.73 314.15 1508.63 305.994L1502.55 282.332Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.49 182.202L1198.86 155.611C1207.59 153.366 1216.5 158.628 1218.74 167.359L1224.56 189.979L1120.15 216.838C1112 218.936 1103.68 214.02 1101.58 205.864L1095.49 182.202Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.64 189.865L1328.01 163.274C1336.74 161.029 1345.64 166.292 1347.89 175.022L1353.71 197.643L1249.29 224.502C1241.14 226.599 1232.82 221.683 1230.72 213.527L1224.64 189.865Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.71 197.643L1457.08 171.052C1465.81 168.806 1474.71 174.069 1476.96 182.8L1482.78 205.42L1378.36 232.279C1370.21 234.377 1361.89 229.461 1359.79 221.305L1353.71 197.643Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.77 205.46L1586.14 178.869C1594.87 176.624 1603.78 181.886 1606.02 190.617L1611.84 213.237L1507.43 240.096C1499.28 242.194 1490.96 237.278 1488.86 229.122L1482.77 205.46Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.93 120.764L1437.3 94.1725C1446.03 91.9272 1454.94 97.1901 1457.18 105.921L1463 128.541L1358.59 155.4C1350.43 157.498 1342.11 152.582 1340.02 144.426L1333.93 120.764Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463 128.548L1566.37 101.957C1575.1 99.7119 1584.01 104.975 1586.25 113.705L1592.07 136.326L1487.66 163.185C1479.51 165.282 1471.19 160.366 1469.09 152.211L1463 128.548Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.763 304.827L722.134 278.236C730.863 275.99 739.769 281.253 742.015 289.984L747.834 312.604L643.421 339.463C635.267 341.561 626.948 336.645 624.85 328.489L618.763 304.827Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.9 312.499L851.272 285.908C860 283.663 868.906 288.926 871.152 297.656L876.971 320.277L772.558 347.136C764.404 349.233 756.085 344.317 753.987 336.161L747.9 312.499Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.971 320.277L980.343 293.686C989.071 291.44 997.977 296.703 1000.22 305.434L1006.04 328.054L901.629 354.913C893.475 357.011 885.156 352.095 883.058 343.939L876.971 320.277Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.04 328.094L1109.41 301.503C1118.14 299.257 1127.04 304.52 1129.29 313.251L1135.11 335.871L1030.69 362.73C1022.54 364.828 1014.22 359.912 1012.12 351.756L1006.04 328.094Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.11 335.869L1238.49 309.278C1247.21 307.033 1256.12 312.296 1258.37 321.027L1264.19 343.647L1159.77 370.506C1151.62 372.603 1143.3 367.687 1141.2 359.532L1135.11 335.869Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.19 343.647L1367.56 317.056C1376.29 314.811 1385.19 320.074 1387.44 328.804L1393.26 351.425L1288.84 378.283C1280.69 380.381 1272.37 375.465 1270.27 367.309L1264.19 343.647Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.26 351.432L1496.63 324.841C1505.36 322.595 1514.26 327.858 1516.51 336.589L1522.33 359.209L1417.92 386.068C1409.76 388.166 1401.44 383.25 1399.35 375.094L1393.26 351.432Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1522.33 359.2L1625.71 332.609C1634.43 330.364 1643.34 335.627 1645.59 344.357L1651.41 366.978L1546.99 393.837C1538.84 395.934 1530.52 391.018 1528.42 382.863L1522.33 359.2Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8093 399.303L117.428 392.713C125.582 390.616 133.908 395.53 136.006 403.686L142.093 427.348L101.704 437.738L91.8165 399.302L91.8093 399.303Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.396 366.144L483.767 339.553C492.496 337.307 501.402 342.57 503.648 351.301L509.466 373.921L405.053 400.78C396.899 402.878 388.58 397.962 386.482 389.806L380.396 366.144Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.177 337.987L355.795 331.397C363.949 329.299 372.268 334.215 374.366 342.371L380.453 366.033L340.064 376.423L330.177 337.987Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.551 276.668L594.17 270.078C602.324 267.98 610.643 272.896 612.74 281.052L618.827 304.714L578.438 315.104L568.551 276.668Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.905 215.355L832.523 208.765C840.677 206.667 848.996 211.583 851.094 219.739L857.181 243.401L816.792 253.791L806.905 215.355Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.28 154.036L1070.9 147.446C1079.05 145.348 1087.37 150.264 1089.47 158.42L1095.56 182.082L1055.17 192.472L1045.28 154.036Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.65 92.717L1309.27 86.127C1317.43 84.0295 1325.75 88.9455 1327.84 97.1012L1333.93 120.763L1293.54 131.153L1283.65 92.717Z",
    fill: "#FF3C00",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 953,
    fill: "white",
    transform: "translate(13 419.576) rotate(-14.4258)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLong);
export default __webpack_public_path__ + "static/media/backgroundLong.0712af790d34e4466cb6f05d629e066d.svg";
export { ForwardRef as ReactComponent };